module.exports = __webpack_public_path__ + "img/intro.53cc3fe7.png";